import { REMOVE_MYWAITROSE_APPLE_WALLET_ITEM } from 'redux/modules/apple-wallet/actions/types';
import initialState from './initial-state';

const removeMyWaitroseAppleWalletItem = () => ({ ...initialState });

export default map => {
  map.set(REMOVE_MYWAITROSE_APPLE_WALLET_ITEM, removeMyWaitroseAppleWalletItem);
  return map;
};
